import React, { useEffect, useState } from "react";
import styled from "styled-components";

const FadeIn: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		setLoaded(true);
	}, []);

	return <StyledFadeIn className={loaded ? "loaded" : ""}>{children}</StyledFadeIn>;
};

export default FadeIn;

const StyledFadeIn = styled.div`
	opacity: 0;
	transition: opacity 0.125s ease-in;

	&.loaded {
		opacity: 1;
	}
`;
